import * as React from "react";
function SvgFacebookPage(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M18.69 24V7.54a.51.51 0 00-1 0v.86a27.36 27.36 0 00-3.5-.4h-.13c-1.54 0-3.36 1-5.33 1h-.04a4.09 4.09 0 01-2.34-.51v8.18a10.43 10.43 0 003 .51c1.93 0 2.83-1 4.68-1a24.58 24.58 0 013.59.33V24h-1.5v1h4.11v-1zm-4.63-8.8a7.22 7.22 0 00-2.65.57 5.49 5.49 0 01-2 .46 8.79 8.79 0 01-2-.26V10a7.57 7.57 0 001.31.11h.06A12.29 12.29 0 0012 9.48a8.92 8.92 0 012-.43h.11a27.48 27.48 0 013.47.36v6.09a25.17 25.17 0 00-3.52-.33z" />
      <path d="M23.59 10a3.21 3.21 0 00-3.43 3.53v2h-2.3v2.67h2.3V25h2.76v-6.84h2.3l.34-2.67h-2.65v-1.7c0-.77.21-1.3 1.32-1.3h1.41v-2.38a18.54 18.54 0 00-2.05-.11z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFacebookPage);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
